import { Grid, makeStyles } from '@material-ui/core'
import { CopilotEngagementCategories } from 'consts/copilotControlConsts'
import React, { useCallback } from 'react'
import PatientListTitle from '../../common/PatientsList/PatientListTitle'
import ScanningScheduleWithCount from './ScanningScheduleWithCount'
import { trackEvent } from 'utils/analyticsUtils'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },
  toggleButton: {
    margin: '2px 3px',
    height: 37,
    color: '#001335',
    backgroundColor: '#E7EAFF',
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 10px',
    cursor: 'pointer'
  },
  allReasonsButton: {
    width: 96,
    height: 84,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: ({ allReasonsSelected }) => (allReasonsSelected ? '#7586FF' : '#E7EAFF')
  },
  reasonsContainer: {
    height: '50%'
  },
  allReasonsLabelsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  reasonLabelContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const PatientsScanningScheduleListHeader = ({ scoreOptions, selectedCategories, setSelectedCategories }) => {
  const handleCategoryClicked = useCallback(
    category => {
      let updatedCategories = []
      if (selectedCategories.includes(category)) {
        updatedCategories = selectedCategories.filter(c => c !== category)
      } else {
        updatedCategories = [...selectedCategories, category]
      }

      trackEvent('Copilot Control - Patients scannig schedule list header - Category clicked', {
        selectedCategories: updatedCategories
      })
      setSelectedCategories(updatedCategories)
    },
    [selectedCategories, setSelectedCategories]
  )

  const classes = useStyles()

  return (
    <Grid container className={classes.root}>
      <Grid item>
        <PatientListTitle />
      </Grid>
      <Grid item>
        <Grid container className={classes.reasonsContainer}>
          <ScanningScheduleWithCount
            containerClassName={classes.toggleButton}
            scoreOption={scoreOptions[CopilotEngagementCategories.Negative]}
            onCategoryClicked={handleCategoryClicked}
            selected={selectedCategories.includes(CopilotEngagementCategories.Negative)}
          />
          <ScanningScheduleWithCount
            containerClassName={classes.toggleButton}
            scoreOption={scoreOptions[CopilotEngagementCategories.Neutral]}
            onCategoryClicked={handleCategoryClicked}
            selected={selectedCategories.includes(CopilotEngagementCategories.Neutral)}
          />
          <ScanningScheduleWithCount
            containerClassName={classes.toggleButton}
            scoreOption={scoreOptions[CopilotEngagementCategories.Positive]}
            onCategoryClicked={handleCategoryClicked}
            selected={selectedCategories.includes(CopilotEngagementCategories.Positive)}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PatientsScanningScheduleListHeader
